import * as React from "react";
import { useTheme, styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircleIcon from "@mui/icons-material/Circle";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import banner1 from "../../../images/banner1b.jpg";
import banner2 from "../../../images/banner2b.jpg";
import banner3 from "../../../images/banner3b.jpg";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: "banner_image1",
    imgPath: banner1,
    title: "We work on delivering unique visual solutions",
    subtitle: "Pushing the boundaries of creativity and technology.",
  },
  {
    label: "banner_image2",
    imgPath: banner3,
    title: "Attractive design from concept to final result",
    subtitle: "We partner with you to create stunning solutions.",
  },
  {
    label: "banner_image3",
    imgPath: banner2,
    title: "Bringing your brand to life in the digital space.",
    subtitle: "We empower your vision through our creativity.",
  },
];

function Banner() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const ColorButton = styled(Button)(() => ({
    color: "#fff",
    width: 225,
    height: 65,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "#000",
    borderColor: "#000",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#000",
      borderColor: "#000",
    },
  }));

  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "15%", sm: "0%" }}>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={5000}
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box>
                <Box
                  component="img"
                  height={{ xs: "30vh", sm: "130vh" }}
                  display={{ xs: "none", sm: "block" }}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    width: "100%",
                  }}
                  src={step.imgPath}
                  alt={step.label}
                />
                <Box
                  display={{ xs: "none", sm: "inline" }}
                  paddingBottom={"3%"}
                  position={"absolute"}
                  top={{ xs: "55%", sm: "25%" }}
                  marginLeft={{ xs: "0%", sm: "0%" }}
                  width={"60%"}
                >
                  <Typography
                    variant="h2"
                    color="#fff"
                    fontWeight={800}
                    padding={"1% 2% 1% 15%"}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    fontWeight={600}
                    textAlign={"left"}
                    padding={"2% 2% 1% 15%"}
                    color={"#fff"}
                  >
                    {step.subtitle}
                  </Typography>
                  <Box padding={"2% 2% 1% 15%"}>
                    <ColorButton
                      component={"a"}
                      variant="outlined"
                      size="medium"
                      href={"/aboutus"}
                      endIcon={
                        <CircleIcon
                          sx={{
                            color: "#33E68C",
                            "&:hover": {
                              color: "#fff",
                            },
                          }}
                        />
                      }
                    >
                      View More
                    </ColorButton>
                  </Box>
                </Box>
                <Box
                  display={{ xs: "block", sm: "none" }}
                  paddingBottom={"3%"}
                  width={"90%"}
                >
                  <Typography
                    variant="h2"
                    color="#fff"
                    fontWeight={700}
                    padding={"40% 3% 1% 3%"}
                    textAlign={"left"}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    fontWeight={600}
                    textAlign={"left"}
                    padding={"4% 3% 1% 3%"}
                    color={"#fff"}
                  >
                    {step.subtitle}
                  </Typography>
                  <Box padding={"4% 2% 1% 4%"}>
                    <ColorButton
                      component={"a"}
                      variant="outlined"
                      size="medium"
                      href={"/aboutus"}
                      endIcon={
                        <CircleIcon
                          sx={{
                            color: "#33E68C",
                            "&:hover": {
                              color: "#fff",
                            },
                          }}
                        />
                      }
                    >
                      View More
                    </ColorButton>
                  </Box>
                </Box>
              </Box>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
    </Box>
  );
}

export default Banner;
